import { createMaxLengthRule } from "./general";

export const SERVICE_CONSTANTS = {
    NEW_SERVICE: 'New product add-on',
    SERVICE_NAME: 'Product add-on name',
    SERVICE_DESCRIPTION: 'Add-on Description',
    ENTER_SERVICE_NAME: 'Enter add-on name',
    ENTER_SERVICE_DESCRIPTION: 'Enter add-on description',
    SERVICE_SKU: 'Product add-on SKU',
    ENTER_SERVICE_SKU: 'Enter add-on SKU',
    BUNDLE_SERVICE: 'Bundle Add-on',
    BUNDLE_SERVICE_DESCRIPTION: 'Turning on Bundle Add-ons will enable the creation of complex add-ons. Keep it off for product-specific add-ons that can be added as add-ons and displayed as additional options on product details pages.',
    SELECT_SERVICE_COUNTRY: 'Select country',
    SERVICE_COUNTRY_TOOLTIP: 'Select country where this product add-on will be available. Both US and CA can be chosen as available.',
    UNIT_OF_MEASUREMENT: 'Unit of Measurement',
    PLACEHOLDER_UNIT_OF_MEASUREMENT: 'i.e, one time payment',
    CANADA_PRICE: 'Canada Price (CA$)',
    USA_PRICE: 'US Price (USD $)',
    PLACE_HOLDER_CANADA_PRICE: 'Enter price in CA$',
    PLACE_HOLDER_USA_PRICE: 'Enter price in USD $',
    LOGISTICS_OPTIONS: 'Logistics Options',
    RESTRICTED_STATES: 'Restricted states',
    RESTRICTED_PROVINCES: 'Restricted provinces',
    RESTRICTED_WAREHOUSES: 'Restricted warehouses',
    RESTRICTED_REGIONS: 'Restricted Regions',
    ADD_RESTRICTED_WAREHOUSE: 'Add restricted warehouse',
    SEARCH_WAREHOUSE: 'Search the warehouse',
    NO_WAREHOUSE: 'No warehouse found',
    ADD_RESTRICTED_PURCHASE_WAREHOUSE: 'Add restricted purchase warehouse',
    ADD_RESTRICTED_RENT_WAREHOUSE: 'Add restricted rent warehouse',
    PURCHASE_WAREHOUSE_SUPPORT_TEXT: `Purchase warehouses are used exclusively for add-ons associated with products available for sale.`,
    RENT_WAREHOUSE_SUPPORT_TEXT: 'Rental warehouses store products intended for rental.',
    PRODUCT_SUPPORT_TEXT: 'Please specify whether this add-on should be applicable to regular purchase products and/or rental products by selecting the appropriate options  below.',
    APPLICABLE_FOR_PURCHASE: 'Applicable for purchase products',
    APPLICABLE_FOR_RENT: 'Applicable for rental products',
    SERVICE_UPDATED: 'Add-on updated successfully',
    SERVICE_CREATED: 'Add-on created successfully',
    SKUS_NOT_FOUND: 'SKU(s) not found',
    SKUS_ALREADY_FOUND: 'SKU(s) already added',
    ADD_VARIANT_SKU_NUMBER: 'Add variant SKU number or multiple SKU numbers separated by comma.',
    VARIANT_SKU_NUMBER: 'Add to Variant SKU number',
    NO_PRODUCTS_ADDED: 'No product variants added.',
    SERVICE_PRODUCTS_LISTING: 'Add-on applied for the following product SKU:',
    CONFIRM_DELETE_SKUS: 'Are you sure you want to remove selected SKU(s)?',
    REMOVE_SKUS: 'Remove SKU',
    SERVICE_CATEGORIES: 'Add-on Categories',
    ARE_YOU_SURE: 'Are you sure you want to delete',
    SERVICE: 'add-on',
    SERVICES: 'Add-ons',
    SERVICE_DELETED: 'Add-on deleted',
    SERVICES_DELETED: 'Add-ons deleted',
    SELECT_MEASUREMENT_UNIT: 'Select measurement unit',
    VARIANT_QTY: 'QTY',
    ADD_TO_SKU: 'Add to SKU',
    OPTIONAL_FOR_SELECTED_SKU: 'Optional for selected SKU',
    IMPORT_PRODUCT_ADDONS_HEADING: 'Add-on products upload',
    ADD_ON: 'Add-on',
    PLEASE_SELECT_VENDOR: 'Please select a vendor to proceed.',
    PLEASE_SELECT_BUSINESS_UNIT: 'Please select a business unit to proceed.',
    SELECT_BUSINESS_UNIT_MESSAGE: 'Please select a business unit to view add-ons',
    TOOLTIP_TO_BE_DETERMINED: 'TBD',
    UNSAVE_CHANGES_DESC: 'You have unsaved changes. Are you sure you want to leave this page?',
    PUBLISH_SERVICE: 'Publish Add-on',
    UNPUBLISH_SERVICE: 'Unpublish Add-on',
    PUBLISH_CONFIRMATION: 'Are you sure you want to publish this add-on?',
    UNPUBLISH_CONFIRMATION: 'Are you sure you want to unpublish this add-on?',
    SERVICE_DRAFTED: 'Add-on has been saved',
    SERVICE_PUBLISHED: 'Add-on has been published',
    SERVICE_UNPUBLISHED: 'Add-on has been unpublished',
    CANNOT_DELETE_PUBLISHED_SERVICE: 'Cannot delete published or unpublished add-ons', 
    PUBLISH_SERVICE_WARNING: 'At least one variant is needed before publishing.',  
}

export const SERVICE_FORM_FIELDS = {
    NAME: 'name',
    DESCRIPTION: 'description',
    TYPE: 'serviceTypeId',
    CODE: 'code',
    SKU: 'sku',
    STATUS: 'publishStatusId',
    VENDOR: 'vendorId',
    COUNTRIES: 'countries',
    MEASUREMENT_UNIT_USA: 'unitOfMeasurementUsaId',
    MEASUREMENT_UNIT_CA: 'unitOfMeasurementCaId',
    IS_BUNDLED_SERVICE: 'isBundledService',
    IS_FOR_CANADA: 'isForCanada',
    IS_FOR_USA: 'isForUSA',
    CANADA_PRICE: 'canadaPrice',
    USA_PRICE: 'usaPrice',
    RESTRICTED_REGIONS: 'restrictedRegions',
    RESTRICTED_WAREHOUSES_PURCHASE: 'restrictedWarehousesPurchase',
    RESTRICTED_WAREHOUSES_RENT: 'restrictedWarehousesRent',
    VARIANTS: 'productVariants',
    CATEGORIES: 'categories',
    OPTIONAL_SKU: 'isOptional'
} as const;

export const SERVICE_FORM_ERRORS = {
    SERVICE_NAME: 'Add-on name is required',
    SERVICE_DESCRIPTION: 'Add-on description is required',
    SERVICE_SKU: 'Add-on SKU is required',
    MAX_CHARACTERS: 'Max {{characters}} characters allowed',
    PRICE_ERROR: 'Price is required',
    COUNTRY: 'Select at least one country',
}


export const SERVICE_PRODUCTS_LINKING_HEADERS = [
    { category: '', columns: ['sku', 'productName', 'quantity', 'isOptional', 'productStatus'] }
];

export const SERVICES_COLUMNS_STORAGE_KEY = 'servicesColumnSettings';
export const SERVICES_FIXED_COLUMNS = ['sku', 'name'];



export const SERVICE_FORM_RULES: { [key: string]: any } = {
    SERVICE_NAME: {
        maxLength: createMaxLengthRule(50, SERVICE_FORM_ERRORS.MAX_CHARACTERS),
        validate: (value: string) => {
            if (value.trim() === '') {
                return SERVICE_FORM_ERRORS.SERVICE_NAME;
            }
            return true;
        }
    },
    SERVICE_SKU: {
        maxLength: createMaxLengthRule(30, SERVICE_FORM_ERRORS.MAX_CHARACTERS),
        validate: (value: string) => {
            if (value.trim() === '') {
                return SERVICE_FORM_ERRORS.SERVICE_SKU;
            }
            return true;
        }
    },
    UNIT_OF_MEASUREMENT_CA: {
        maxLength: createMaxLengthRule(100, SERVICE_FORM_ERRORS.MAX_CHARACTERS),
    },
    UNIT_OF_MEASUREMENT_USA: {
        maxLength: createMaxLengthRule(100, SERVICE_FORM_ERRORS.MAX_CHARACTERS),
    },
    IS_FOR_USA: (clearErrors: any) => ({
        // Required if none of the countries are selected
        validate: (value: boolean, values: any) => {
            if (!value && !values.isForCanada) {
                return SERVICE_FORM_ERRORS.COUNTRY;
            }
            clearErrors(SERVICE_FORM_FIELDS.USA_PRICE); // Clear error for price if country is checked
            clearErrors(SERVICE_FORM_FIELDS.IS_FOR_USA);
            return true;
        }
    }),
    IS_FOR_CANADA: (clearErrors: any) => ({
        // Required if none of the countries are selected
        validate: (value: boolean, values: any) => {
            if (!value && !values.isForUSA) {
                return SERVICE_FORM_ERRORS.COUNTRY;
            }
            clearErrors(SERVICE_FORM_FIELDS.CANADA_PRICE); // Clear error for price if country is checked
            clearErrors(SERVICE_FORM_FIELDS.IS_FOR_CANADA);
            return true;
        }
    }),
    CANADA_PRICE: (clearErrors: any) => ({
        maxLength: createMaxLengthRule(12, SERVICE_FORM_ERRORS.MAX_CHARACTERS),
        validate: (value: string, values: any) => {
            if (!Number(value) && values.isForCanada) {
                return SERVICE_FORM_ERRORS.PRICE_ERROR;
            }
            clearErrors(SERVICE_FORM_FIELDS.CANADA_PRICE);
            return true;
        }
    }),

    USA_PRICE: (clearErrors: any) => ({
        maxLength: createMaxLengthRule(12, SERVICE_FORM_ERRORS.MAX_CHARACTERS),
        validate: (value: string, values: any) => {
            if (!Number(value) && values.isForUSA) {
                return SERVICE_FORM_ERRORS.PRICE_ERROR;
            }
            clearErrors(SERVICE_FORM_FIELDS.USA_PRICE);
            return true;
        }
    }),
};

export enum SERVICE_TYPE {
    BUNDLE = 'bundle',
    ADD_ON = 'add-on',
}

export enum ADDON_STATUS_CODE {
    DRAFT = 'draft',
    PUBLISHED = 'published',
    UNPUBLISHED = 'unpublished',
}

export const SERVICE_PRODUCTS_IMPORT_HEADERS = ['SKU ID', 'Optional Add-on', 'QTY']
export const PRODUCT_ADDONS_DOWNLOAD_TEMPLATE = '/Add-on Import.xlsx';
export const PRODUCT_ADDONS_IMPORT_PROGRESS_SOCKET = 'serviceProductsProgress';
export const PRODUCT_ADDONS_IMPORT_COMPLETION_SOCKET = 'serviceProductsResult';
export const PRODUCT_ADDONS_IMPORT_CONTAINER = 'product-addons';

export const emptyProductAddonExportObject = {
    'SKU ID': '',
    'Optional Add-on': '',
    'QTY': ''
};
export const DEFAULT_UOM_CODE = 'day';

export const SKU_QUANTITY = { MIN: 1, MAX: 999 };

export const MAX_ADDON_QUANTITY = 9999;
